import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://us-central1-asyncentric-tech.cloudfunctions.net/app/',
    // baseURL: 'http://localhost:5000/',
});

export default instance;